var notificationType = require('./app-mobile/notification-types');

var cookieHelper = {
    checkCookie: function(){
        try {
            // Create cooki
            document.cookie = 'cookietest=1';
            var ret = document.cookie.indexOf('cookietest=') != -1;
            // Delete cookie
            document.cookie = 'cookietest=1; expires=Thu, 01-Jan-1970 00:00:01 GMT';
            return ret;
        }
            catch (e) {
            return false;
        }
    },

    showOnloadNotification: function(){
        if(this.checkCookie()) return;

        bookedby.app.confirmForm && bookedby.app.confirmForm.once('afterRender', function (view) {
            view.show(_.noop, _.noop, {
                title: 'Cookies',
                message: 'Please enable cookies to get full functionality of the application.',
                confirmLabel: 'Confirm',
                showCancelLabel: false,
                allowClose: false
            });
        });

        bookedby.app.viewManager.notifyView && bookedby.app.viewManager.notifyView.once('afterRender', function(view) {
            view.notify({
                showAgreeButton: true,
                showCancelButton: false,
                agreeButtonText: 'Ok',
                notificationType: notificationType.WARNING,
                notificationTitle: 'Cookies',
                notificationMessage: 'Please enable cookies to get full functionality of the application.'
            });
        })
    }
}

module.exports = cookieHelper;